import PropTypes from 'prop-types';
import { ToastNotification } from 'ypf-pas-general-ui-components/dist';
import { useCallback, useState, createContext } from 'react';

const ToastContext = createContext();

export default ToastContext;

const paramsError = {
  position: 'top-right',
  autoClose: false,
  hideProgressBar: true,
  closeButton: true,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const setNewToast = useCallback((toast) => {
    const isError = typeof toast?.type === 'string' && toast.type.toUpperCase() === 'ERROR';

    const baseOptions = isError ? paramsError : {};
    const finalToast = {
      ...toast,

      options: { ...baseOptions, ...(toast?.options || {}) }
    };

    setToasts(() => [finalToast]);
  }, []);

  const closeToast = () => {
    setToasts((tst) => tst.slice(1), 3000);
  };

  return (
    <ToastContext.Provider
      value={{
        setNewToast,
        closeToast
      }}
    >
      {children}
      {toasts?.map((toast, index) => (
        <ToastNotification
          // eslint-disable-next-line react/no-array-index-key
          key={`${index}-toast.mensaje`}
          options={toast?.options || null}
          toast={toast}
        />
      ))}
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired
};
